import { useEffect, useState } from 'react';

export const useLoadGoogleMaps = (apiKey: string | undefined) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState<Error | null>(null);

  useEffect(() => {
    // Check if already loaded
    if (window.google?.maps?.places) {
      setIsLoaded(true);
      return;
    }

    // Check if script is already being loaded
    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com/maps/api"]'
    );
    
    if (existingScript) {
      // Wait for existing script to load
      existingScript.addEventListener('load', () => setIsLoaded(true));
      existingScript.addEventListener('error', (e) => setLoadError(new Error('Failed to load Google Maps')));
      return;
    }

    if (!apiKey) {
      setLoadError(new Error('Google Maps API key is missing'));
      return;
    }

    // Create and load script
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    
    script.addEventListener('load', () => {
      setIsLoaded(true);
    });
    
    script.addEventListener('error', () => {
      setLoadError(new Error('Failed to load Google Maps API'));
    });

    document.head.appendChild(script);

    return () => {
      // Cleanup is tricky with Google Maps, so we'll leave it loaded
      // script.remove();
    };
  }, [apiKey]);

  return { isLoaded, loadError };
};

